import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ShieldAlert } from "lucide-react";
import { useSetupProgress } from "../../Moduels/Context/SetupProgressContext";
import { canProcessPayroll, getPayrollReadinessItems } from "../../services/setupProgressService";
import BrixigoPageLoader from "../common/BrixigoPageLoader";
import "../../styles/setupProgress.css";

export default function PayrollReadinessGate({ children }) {
  const { progress } = useSetupProgress();

  if (progress?.loading) {
    return <BrixigoPageLoader message="Checking payroll readiness…" />;
  }

  const ready = canProcessPayroll(progress);
  if (ready) return children;

  const items = getPayrollReadinessItems(progress);
  const mandatory = ["org_profile", "employees", "payroll_settings", "attendance_config", "salary_components"];

  return (
    <div className="pr-gate-page">
      <div className="pr-gate-card">
        <div className="pr-gate-icon">
          <ShieldAlert size={32} />
        </div>
        <h1 className="pr-gate-title">Payroll Readiness Check</h1>
        <p className="pr-gate-sub">
          Payroll cannot be processed until all mandatory setup items are completed.
          You can still add employees and configure modules in any order.
        </p>

        <ul className="pr-checklist">
          {items.map((item) => {
            const isMandatory = mandatory.includes(item.id);
            return (
              <li key={item.id} className={item.complete ? "done" : "pending"}>
                {item.complete ? <CheckCircle2 size={20} /> : <Circle size={20} />}
                <div className="pr-check-text">
                  <span className="pr-check-label">{item.label}</span>
                  {item.description && (
                    <span className="pr-check-desc">{item.description}</span>
                  )}
                </div>
                {!item.complete && (
                  <Link to={item.path} className="pr-configure-btn">
                    Configure
                  </Link>
                )}
                {!isMandatory && !item.complete && (
                  <span className="pr-optional">Optional</span>
                )}
              </li>
            );
          })}
        </ul>

        <div className="pr-gate-footer">
          <Link to="/settings" className="sp-btn sp-btn-primary">
            Open Settings
          </Link>
        </div>
      </div>
    </div>
  );
}
